import { createContext, useContext } from "react";
export const NestLevelContext = createContext(0);
export const useNestLevel = () => useContext(NestLevelContext);
